export type PlayerProfile = {
  id: string;
  handle: string;
  rating: number;
  games: number;
  wins: number;
  losses: number;
};

const adjectives = ['푸른', '고요한', '힘찬', '슬기로운', '날쌘', '든든한', '빛나는', '차분한'];
const nouns = ['마', '상', '차', '포', '졸', '장군', '기수', '수읽기'];

export const ratingRank = (rating: number) => {
  if (rating >= 2300) return '온라인 5단';
  if (rating >= 2150) return '온라인 4단';
  if (rating >= 2000) return '온라인 3단';
  if (rating >= 1850) return '온라인 2단';
  if (rating >= 1700) return '온라인 1단';
  const kyu = Math.max(1, Math.min(18, Math.ceil((1700 - rating) / 70)));
  return `온라인 ${kyu}급`;
};

const createProfile = (): PlayerProfile => {
  const id = crypto.randomUUID();
  const seed = [...id].reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return {
    id,
    handle: `${adjectives[seed % adjectives.length]}${nouns[Math.floor(seed / 7) % nouns.length]}${String(seed % 900 + 100)}`,
    rating: 1500,
    games: 0,
    wins: 0,
    losses: 0,
  };
};

export const loadProfile = (): PlayerProfile => {
  const stored = localStorage.getItem('janggi-maru-profile');
  if (stored) {
    try { return JSON.parse(stored) as PlayerProfile; } catch { /* create below */ }
  }
  const profile = createProfile();
  saveProfile(profile);
  return profile;
};

export const saveProfile = (profile: PlayerProfile) => localStorage.setItem('janggi-maru-profile', JSON.stringify(profile));
